import axios from 'axios';

import { Printer } from 'types/PrintingMS';
import { getMSEndpointFromLS } from 'reducers/installer';
import { withPrintingStatisticsFunction } from 'actions/integrations/printer/utils';
import { STATISTIC_ENTRY_TYPES } from 'utils/statistics/Statistics';

const { WebSocket } = window;

const defaultBaseUrl = `https://localhost.erply.com:5000/`;

function getBaseUrl(): string {
  const baseUrl = getMSEndpointFromLS('goMS');
  return baseUrl || defaultBaseUrl;
}

export async function getPrinterList(full?: boolean): Promise<Printer[]> {
  const baseUrl = getBaseUrl();
  try {
    const response = await axios.get(`${baseUrl}getprinterlist`, {
      params: { full },
    });
    return response.data;
  } catch (error) {
    return [];
  }
}

/** @since printing-microservice v2.1.65 */
export async function getSelectedPrinter(): Promise<{
  /** @example "EPSON-TM-T20II" */
  Name: string;
  /** @example "epson" */
  VendorID: string;
  /** @example "TMT20" */
  ProductID: string;
  /** @example "" */
  ConnectionType: string;
  /** @example 30 */
  CharPerLine2: number;
  /** @example 378 */
  PixelPerLine2: number;
  /** @example 42 */
  CharPerLine3: number;
  /** @example 546 */
  PixelPerLine3: number;
  Options: {
    /** @example "30" */
    CPL2: string | number;
    /** @example "42" */
    CPL3: string | number;
    /** @example "378" */
    PPL2: string | number;
    /** @example "546" */
    PPL3: string | number;
    /** @example "3" */
    papersize: string | number;
  };
  RequiresRendering: boolean;
}> {
  const baseUrl = getBaseUrl();
  return axios.get(`${baseUrl}getprinter`).then(res => res.data);
}

export async function openCashDrawer(): Promise<void> {
  const baseUrl = getBaseUrl();
  return axios.get(`${baseUrl}opencashdrawer`);
}

async function printReceiptHttpBase(
  salesDocumentId: number,
  templateId: string,
  clientCode: string,
  sessionKey: string,
): Promise<void> {
  const baseUrl = getBaseUrl();
  return axios.post(
    `${baseUrl}print`,
    { salesDocumentId, templateId, printoutType: 'PATCH_SCRIPT' },
    {
      headers: {
        clientCode,
        sessionKey,
      },
    },
  );
}

export const printReceiptHttp = withPrintingStatisticsFunction({
  description: 'Printing Patchscript via printing-MS using HTTP',
  itemType: STATISTIC_ENTRY_TYPES.TypeNameDataProcessing,
})(printReceiptHttpBase);

async function printReceiptWsBase(script: string): Promise<string> {
  const url = new URL(getBaseUrl());
  url.protocol = 'wss:';

  return new Promise<string>((resolve, reject) => {
    const ws = new WebSocket(url.toString());
    ws.onerror = () => reject(new Error('Printing failed with error'));
    ws.onclose = () => reject(new Error('Printing failed with error'));
    ws.onopen = () => {
      ws.send(script);
      resolve(script);
    };
  });
}

export const printReceiptWs = withPrintingStatisticsFunction({
  description: 'Printing Patchscript via printing-MS using Websocket',
  itemType: STATISTIC_ENTRY_TYPES.TypeNameDataProcessing,
})(printReceiptWsBase);
